










































































































































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY as PARENT_STORE_KEY } from '../_store';
import { STORE_KEY, store } from './_store';
import Attachments from '@/components/Controls/Attachments.vue';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(PARENT_STORE_KEY, [
      'relatedFactsList'
    ]),
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta', 'storages', 'equipments'
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      logo_id: { required },
      activity_id: { required },
      base_id: { required },
      starter_type: { required },
      starter_type_id: { required },
      number: { required },
      rotate_id: {  },
    }

    return {
      form: rules
    }
  },
  components: {
    Attachments
  }
})
export default class ShiftVDPForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;
  @Prop({ type: String }) documentId!: any;

  document!: any
  form!: any
  relatedFactsList!: any
  equipments!: any

  logo_id: number|null = null;
  group: number|null = null;

  groups: any[] = [
    {id: 'm', label: 'M'},
    {id: 't', label: 'T'},
    {id: 'm+t', label: 'M+T'},
  ]
  prefilterTrigger: boolean = false;

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];
  public rotates: any[] = [];
  public activity_id: any = null;

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id,
        full_id: this.documentPreview.full_id
      });
    }
  }

  checkAllowLine(row: any) {
    return row.base_ids.filter((item: any) => {
      return !item || (item == this.form.base_id && !row.volume_is_full) || row.volume_type == 'pail' 
    }).length > 0 
  }

  changeValue(field: string, value: any) {
    if (field == 'base_id') {
      this.prefilterTrigger = !this.prefilterTrigger;
    }
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });
  }

  addItem(storage_id: any) {
    this.$store.dispatch(`${STORE_KEY}/addItem`, {storage_id});
  }

  removeItem(index: any) {
    this.$store.dispatch(`${STORE_KEY}/removeItem`, index);
  }

  addAttachments(file: any) {
    this.$store.dispatch(`${STORE_KEY}/addAttachments`, {newValue: file});
  }

  changeStorageValue(index: number, field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeStorageValue`, {
      index, field, newValue: value
    });
  }

  onStarterTypeChange($event: any) {
    console.log($event)
    if ($event && $event.label) {
      this.form.activity_id = $event.activity_id;
      console.log($event)
      this.rotates = $event.rotate_ids
    }
  }

  prefilterStarterTypes(item: any, index: number) {
    return this.form && item.starter_type == this.form.starter_type;
  }

  prefilterRotates(item: any, index: number) {
    return this.rotates.includes(item.id);
  }

  onLineObject($event: any) {
    if ($event && $event.label) {
      this.$store.dispatch(`${STORE_KEY}/setEquipments`, $event.equipments.filter((item: any) => item.equipment_id))
    }
  }

  changeEqupmentValue(idx: number, $event: any) {
    this.$store.dispatch(`${STORE_KEY}/changeEqupmentValue`, {
      idx, active: $event
    })
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close', result);
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

